(function ($, window) {
    const qnonce = settings.nonce;

    $(document).on('click', '.quick-view-js', function () {

        const $button = $(this);
        const postId = $button.data('id');
        const widgetId = $button.data('widget-id') || $button.closest('.prodigy-custom-template').find('.products-widget-id').first().val();
        const modalId = $button.data('modal-id');
        const $modal = $('#' + modalId);

        window.code_happened = false;
        $.ajax({
            type: "POST",
            url: ajaxurl,
            data: {
                action: 'prodigy-quick-edit',
                post_id: postId,
                products_widget_id: widgetId,
				nonce: qnonce
            },
            cache: false,
            success: function (html) {
               $modal
                    .off('show.bs.modal.prodigyQuickView')
                    .on('show.bs.modal.prodigyQuickView', function () {
                        $(this).find('.modal-body').html(html);
                    });

                $modal
                    .off('shown.bs.modal.prodigyQuickView')
                    .on('shown.bs.modal.prodigyQuickView', function () {
                        if (typeof window.prodigyProduct === 'undefined') {
                            return;
                        }

                        prodigyProduct.init();
                        prodigyProduct.set_variant_data();

                        if (!prodigyProduct.is_variants()) {
                            prodigyProduct.get_master_variant_data();
                        }

                        prodigyProduct.set_elementor_options();
                        prodigyProduct.set_product_counter();

                        prodigyProduct.add_item_to_cart();
                        prodigyProduct.reset_focus_to_press_enter();

                        if (typeof window.prodigyProductBulk !== 'undefined') {
                            prodigyProductBulk.bulk_showing_manager();
                        }

                        if (prodigyProduct.is_tiered_price) {
                            prodigyProduct.get_tiered_prices_range_ajax();
                        }

                        if (typeof window.prodigyProductBulk !== 'undefined') {
                            prodigyProductBulk.set_bulk_variants_data();
                        }

                        if (prodigyProduct.is_bulk()) {
                            prodigyProduct.set_bulk();
                        }

                        if (prodigyProduct.is_tiered_price) {
                            prodigyProduct.get_tiered_prices_range_ajax(prodigyProduct.get_master_variant_id());
                            prodigyProduct.close_tiered_price_popup();
                        }

                        if (prodigyProduct.is_swatches()) {
                            prodigyProduct.change_swatch_value();
                        }

                        prodigyProduct.update_variants_dropdown();

                        if (
                            typeof window.prodigyProductGallery !== 'undefined' &&
                            typeof window.prodigyProductGallery.set_product_gallery === 'function'
                        ) {
                            window.prodigyProductGallery.set_product_gallery();
                        }

                        if (typeof prodigyProduct.set_attribute_value_options === 'function') {
                            prodigyProduct.set_attribute_value_options();
                        }
                    });

                $modal.modal('show');
            },
            error: function (jqXHR, textStatus, errorThrown) {
                console.error('AJAX Error:', textStatus, errorThrown);
                $modal.find('.modal-body').text('An error occurred. Please try again.');
                $modal.modal('show');
            }
        });
    });
})(jQuery, window);
